<template>
  <div class="page-about">

    <div v-for="(block, index) in blocks" :key="`${index}`">
      <info-block :data="block"></info-block>
    </div>

    <div class="container is-gap-top is-gap-top-bottom" data-aos="fade-in" data-aos-once="true">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-6" v-for="(staff, index) in staffs" :key="`${index}`">

          <div class="columns is-gapless is-flex">
            <div class="column is-5">
              <div class="rounded-wrapper"
                style="margin:12px;margin-left:auto;margin-right:auto;background-size:cover;"
                :style="{ backgroundImage: (staff && staff.image) ? `url('${staff.image.path}')` : `url('${defaultImage}')` }"
                role="img"
                :alt="staff.image && staff.image.description"
                :title="staff.image && staff.image.description"
                :aria-label="staff.image && staff.image.description">
                <!-- <img :src="(staff && staff.image) ? `${staff.image.path}${staff.name && staff.name.replace(/\s/g, '+')}` : defaultImage" /> -->
              </div>
            </div>

            <div class="column is-7 has-text-left">
              <div class="is-pad">
                <p>
                  <b>{{ staff.title }}</b>
                </p>
                <p class="is-gap-top">{{ staff.subtitle }}</p>
                <el-button
                  class="button is-gap-top is-gap-bottom color-green-bg"
                  @click="onDialog(index)">
                  Read bio
                </el-button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <dialogg
      :visible="dialogVisible"
      :no-cancel="true"
      :ok-string="'Close Window'"
      :width-desktop="'85%'"
      :width-mobile="'90%'"
      @on-close="() => { dialogVisible = false }"
      @on-submit="onDialogSubmit">
      <div class="has-text-left" v-if="selectedItem">
        <h1 v-if="selectedItem.title" style="word-break:break-word;">
          {{ selectedItem.title }}
        </h1>
        <hr />
        <h3 class="is-gap-top is-gap-large-bottom"
          v-if="selectedItem.subtitle"
          style="word-break:break-word;">
          {{ selectedItem.subtitle }}
        </h3>
        <div class="showdown is-gap-top"
          v-html="Util.string.showdown(selectedItem.content)"
          style="word-break:break-word;">
        </div>
        <h3 class="is-gap-large-top"
          v-if="selectedItem.link"
          style="word-break:break-word;margin-top:36px;">
          Contact:
          <a :href="`mailto:${selectedItem.link}`">
            {{ selectedItem.link }}
          </a>
        </h3>
      </div>
    </dialogg>

  </div>
</template>

<script>
import Util from '@/util'
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/site'

import InfoBlock from '@/pages/base/infoblock'
import Dialogg from '@/components/dialog'

const MemberPhoto = 'https://via.placeholder.com/320x210.png?text='

export default {
  name: 'page-about',
  props: {
    // msg: String
  },
  components: {
    InfoBlock,
    Dialogg,
  },
  data () {
    return {
      loading: false,
      isDesktop: true,
      defaultImage: `${MemberPhoto}Photo`,
      blocks: [],
      staffs: [],
      selectedIndex: -1,
      dialogVisible: false,
    }
  },
  computed: {
    Util: function () {
      return Util
    },

    selectedItem: function () {
      let index = this.selectedIndex
      let list = this.staffs
      if (index == null || index >= (list && list.length)) return {}
      return list[index]
    },
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    await this.refresh()
  },
  methods: {
    async refresh () {
      try {
        this.$set(this, 'loading', true)
        let promises = []
        let promise
        promise = this.getBlocks()
        promises.push(promise)
        promise = this.getStaffs()
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getBlocks () {
      this.$set(this, 'blocks', [])
      let data = await Site.infoNamedLike('page-about')
      this.$set(this, 'blocks', data)
    },

    async getStaffs () {
      this.$set(this, 'staffs', [])
      let data = await Site.staffs()
      this.$set(this, 'staffs', data)
    },

    onDialog (index) {
      this.$set(this, 'selectedIndex', index)
      this.$set(this, 'dialogVisible', true)
    },

    onDialogSubmit () {
      this.$set(this, 'dialogVisible', false)
    },
  }
}
</script>

<style lang="scss" src="../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../styles/app_setting.scss";

.page-about {
  .rounded-wrapper {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background-color: lightgray;
    background-repeat: no-repeat;
    background-color: #dedede;
    background-position: 50% 50%;
    background-size: auto 100%;
  }
}

</style>
